export default __webpack_public_path__ + "static/media/icon-pencil.3df6818f.svg";